


















































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'
import UserQuestion from '../../../api/v2/models/user_question'
import UserAnswer from '../../../api/v2/models/user_answer'
import Comment from '../../../api/v2/models/comment'
import QuestionRelative from '../../../api/v2/models/question_relative'
import CommentForm from '../../../api/v2/forms/comment'
import AnswerForm from '../../../api/v2/forms/answer'
import VoteForm from '../../../api/v2/forms/vote'
import UserQuestionForm from '../../../api/v2/forms/user_question'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import CommentComponent from '../atoms_molecules/Comment.vue'
import CommentCreation from '../atoms_molecules/CommentCreation.vue'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import QuestionSidebar from '../organisms/UserQuestionSidebar.vue'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { headerState } from '../../stores/header'
import {makeChannel, removeChannel} from '../../../../action_cable/cable'

@Component({
  components: {
    ConfirmDialog,
    Simplemde,
    QuestionSidebar,
    CommentComponent,
    CommentCreation,
    FileIcon
  }
})
export default class UserQuestionDetail extends Vue {
  question: UserQuestion | null = null
  newAnswer: string = ''
  answerFiles: File[] = []
  course: QuestionRelative
  lesson: QuestionRelative
  mobile: boolean = checkMobile()
  channel: any = null
  $refs: {
    confirm: ConfirmDialog
  }

  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'マイ質問',
      disabled: false,
      exact: true,
      to: '/classroom/questions'
    }
  ]

  get user() {
    return userState.user
  }

  async created() {
    try {
      await this.getCurrentQuestion()
      if (this.question) {
        this.createCommentChannel()
      }
      headerState.setTitle(this.question.title)

      this.course = this.question.questionRelatives.find((relative) => relative.relativeableType == 'Course')!
      if (this.course) {
        this.breadcrumbs.push({
          text: this.stringTruncate(this.course.name, 5),
          disabled: false,
          exact: true,
          to: `/classroom/questions?course_id=${this.course.relativeableId}&type=list`
        })
      }

      this.lesson = this.question.questionRelatives.find((relative) => relative.relativeableType == 'Lesson')!
      if (this.lesson) {
        this.breadcrumbs.push({
          text: this.stringTruncate(this.lesson.name, 5),
          disabled: false,
          exact: true,
          to: `/classroom/questions?lesson_id=${this.lesson.relativeableId}&type=list`
        })
      }

      this.breadcrumbs.push({
        text: this.stringTruncate(this.question.title, 5),
        disabled: true,
        exact: false,
        to: ''
      })
    } catch (e) {
    } finally {
    }
  }

  async getCurrentQuestion() {
    this.question = await api.userQuestion.show(this.$route.params.questionId)
  } 

  updated() {
    this.$nextTick(() => {
      if (this.$route.hash) {
        const el = document.querySelector(this.$route.hash)
        el && el.scrollIntoView()
      }
    })
  }

  stringTruncate(str, length){
    if (checkMobile()){
      var dots = str.length > length ? '...' : '';
      return str.substring(0, length) + dots;
    } else {
      return str
    }
  };

  async createComment(newComment: string) {
    try {
      const commentForm = new CommentForm()
      commentForm.body = newComment
      commentForm.commentableId = parseInt(this.$route.params.questionId)
      commentForm.commentableType = 'Question'
      await api.comment.create(commentForm)
      this.question = await api.userQuestion.show(this.$route.params.questionId)
      this.question.showCommentForm = false
    } catch (e) {
    } finally {
    }
  }

  async createAnswerComment(newComment: string, answer: UserAnswer) {
    try {
      const commentForm = new CommentForm()
      commentForm.body = newComment
      commentForm.commentableId = answer.id
      commentForm.commentableType = 'Answer'
      await api.comment.create(commentForm)
      this.question = await api.userQuestion.show(this.$route.params.questionId)
      answer.showCommentForm = false
    } catch (e) {
    } finally {
    }
  }

  async createAnswer() {
    try {
      const answerForm = new AnswerForm()
      answerForm.body = this.newAnswer
      answerForm.question_id = this.$route.params.questionId
      answerForm.materials = this.answerFiles
      await api.answer.create(answerForm)

      this.newAnswer = ''
      this.answerFiles = []
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async updateQuestion(question: UserQuestion) {
    try {
      const questionForm = new UserQuestionForm()
      questionForm.body = this.question!.body
      questionForm.questionType = this.question!.questionType
      questionForm.materials = this.question!.files
      await api.userQuestion.update(this.question!.id, questionForm)

      this.question!.files = []
      question.isEditing = false
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async updateAnswer(answer: UserAnswer) {
    try {
      const answerForm = new AnswerForm()
      answerForm.body = answer.body
      answerForm.materials = answer.files
      await api.answer.update(answer.id, answerForm)

      answer.files = []
      answer.isEditing = false
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async updateComment(comment: Comment) {
    try {
      await api.comment.update(comment.id, { body: comment.body })
      comment.isEditing = false
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async setBestAnswer(answer: UserAnswer, accepted: 'false') {
    try {
      const answerForm = new AnswerForm()
      answerForm.accepted = accepted
      await api.answer.update(answer.id, answerForm)

      answer.isEditing = false
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async deleteQuestion(questionId: number) {
    try {
      if (await (this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.userQuestion.delete(questionId.toString())
        this.$router.replace({ name: ROUTER_NAME.MY_USER_QUESTION_LIST })
      }
    } catch (e) {
    } finally {
    }
  }

  async deleteAnswer(answerId: number) {
    try {
      if (await(this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.answer.delete(answerId)
        this.question = await api.userQuestion.show(this.$route.params.questionId)
      }
    } catch (e) {
    } finally {
    }
  }

  async deleteComment(commentId: number) {
    try {
      if (await(this.$refs.confirm as any).open('本当によろしいですか？')) {
        await api.comment.delete(commentId)
        this.question = await api.userQuestion.show(this.$route.params.questionId)
      }
    } catch (e) {
    } finally {
    }
  }

  async upVote(voteMark, votableId, votableType) {
    if (voteMark == 1) {
      return
    }
    try {
      const voteForm = new VoteForm()
      voteForm.value = Math.min(voteMark + 1, 1)
      voteForm.votableId = votableId
      voteForm.votableType = votableType
      await api.vote.create(voteForm)
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  async downVote(voteMark, votableId, votableType) {
    if (voteMark == -1) {
      return
    }
    try {
      const voteForm = new VoteForm()
      voteForm.value = Math.max(voteMark - 1, -1)
      voteForm.votableId = votableId
      voteForm.votableType = votableType
      await api.vote.create(voteForm)
      this.question = await api.userQuestion.show(this.$route.params.questionId)
    } catch (e) {
    } finally {
    }
  }

  downloadFile(link) {
    window.open(`${location.origin}/${link}`)
  }

  @Watch('$route')
  async changeRoute(val, oldVal) {
    try {
      this.question = await api.userQuestion.show(this.$route.params.questionId)
      headerState.setTitle(this.question.title)
    } catch (e) {
    } finally {
    }
  }

  createCommentChannel() {
    removeChannel('QuestionCommentChannel')
    this.channel = makeChannel(
      'QuestionCommentChannel',
      async (e) => {
        this.getCurrentQuestion()
      },
      () => {
        this.channel.send({
          action: 'follow',
          data: {
            relativeable_id: this.question.id,
            relativeable_type: 'Question'
          }
        })
      },
    )
  }
}
